<template>
    <div class="relative">
        <div
            class="fixed bg-white bg-opacity-75 top-0 right-0 py-2 px-2 rounded-bl-xl z-[1] h-[20%] max-h-[50px] w-[30%] max-w-[100px]">
            <div class="logo_mask w-full h-full bg-primary"></div>
        </div>

        <div
            class="absolute flex flex-col gap-2 bg-white mt-4 bg-opacity-75 top-0 min-h-screen left-4 py-2 px-2 rounded-t-xl z-[1] w-[50%] max-w-[250px]">

            <div v-for="item in props" class="rounded-xl w-full">
                <a v-bind:href="'#'" class="flex justify-between h-full">
                    <div class="flex items-center relative justify-center h-[80px] w-[80px] mb-2 mr-2">
                        <img slot="image" v-bind:src="item.spotlightimage" alt=""
                            class="w-full h-full text-gray-200 object-cover shadow-lg rounded-xl animate-in fade-in transition duration-300" />
                        <div v-if="item.prices && item.prices.priceperNight / item.prices.multiplier < 99999 && !item.prices.priceperNight < 1 && item.prices.multiplier != 1 && item.prices.multiplier != 100"
                            class="absolute left-2 top-2 px-4 h-10 flex justify-center items-center bg-black bg-opacity-50 text-gray-100 backdrop-blur-sm shadow-lg text-sm rounded-full">
                            <div class="flex justify-center items-center" v-if="item.prices.priceperNight / item.prices.multiplier >
                                item.prices.priceperNight">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill=currentColor
                                    viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                    <path
                                        d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                                </svg>
                                {{ $t('Price drop!') }}
                            </div>
                            <div
                                v-else-if="item.prices && item.prices.priceperNight / (item.prices.multiplier / 100) < item.prices.priceperNight">
                                {{ $t('Popular!') }} </div>
                        </div>
                    </div>
                    <div class="flex flex-col py-2 gap-4 justify-center flex-1">
                        <div class="pr-2 flex flex-col justify-center items-start">
                            <h4 class="mb-1 font-bold text-sm leading-4 break-word">{{ item.name.split(",")[0] }}</h4>
                            <div class="flex items-center">
                                <span class="text-xs leading-5">{{ item.city }}</span>
                            </div>
                        </div>
                        <div class="flex flex-col gap-4 justify-center items-start">
                            <h5 v-if="item.prices && item.prices.price">
                                <span class="font-bold">€{{ item.prices.price.toFixed(2) }} </span>
                            </h5>
                            <div class="font-bold text-base leading-4" v-if="item.score">
                                <div class="flex items-center">
                                    <svg class="w-4 h-4 text-primary mr-1" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path
                                            d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                    </svg>
                                    <p class="text-sm font-bold text-gray-900">4.95</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <l-map ref="map" class="map !h-screen w-full fixed top-0 z-0 dark:bg-neutral-900"
            :options="{ zoomControl: false, scrollWheelZoom: false, smoothWheelZoom: true, smoothSensitivity: 6 }"
            :zoom="zoom" :center="[defaultPos[0], defaultPos[1]]" :max-zoom="maxZoom">
            <l-tile-layer :url="url" :attribution="attribution" :accessToken="accessToken"
                :options="{ maxZoom: maxZoom }"></l-tile-layer>
        </l-map>
    </div>
</template>
  
<script>
import { LMap, LTileLayer, LMarker, LPopup, LIcon, LControlZoom } from "vue2-leaflet";
import moment from "moment";
import VueCookies from 'vue-cookies'
import Leaflet from "../leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LIcon,
        LControlZoom,
        'v-marker-cluster': Vue2LeafletMarkerCluster,
    },
    data() {
        return {
            client: JSON.parse(this.$attrs.client),
            props: this.$attrs.props ? JSON.parse(this.$attrs.props) : [],
            dataloaded: false,
            url: "https://tile.jawg.io/241a2530-2ad8-4bbe-b7ab-cc3dc94c489b/{z}/{x}/{y}{r}.png?access-token=vFzDRJ0kKfQsGhrWgc5NGVucII5tbQCySVMLnULzyyR54PZgfQsmNnY3quSTAQGa",
            darkurl: "https://tile.jawg.io/2d25a5ef-17c9-478a-818e-e89646afe989/{z}/{x}/{y}{r}.png?access-token=vFzDRJ0kKfQsGhrWgc5NGVucII5tbQCySVMLnULzyyR54PZgfQsmNnY3quSTAQGa",
            attribution:
                '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            accessToken: 'vFzDRJ0kKfQsGhrWgc5NGVucII5tbQCySVMLnULzyyR54PZgfQsmNnY3quSTAQGa',
            defaultPos: this.$attrs.defaultPost ?? [53.21938362423643, 6.568228226784906],
            zoom: 14,
            maxNativeZoom: 18,
            maxZoom: 20,
        };
    },
    computed: {
        newCenter: function () {

        }
    }
};
</script>